"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { createContext, useContext } from 'react';

const FormComponentsContext = createContext(null);
FormComponentsContext.displayName = "FormComponentsContext";
function useFormComponents() {
  const ctx = useContext(FormComponentsContext);
  if (!ctx) {
    throw new Error("useFormComponents must be used within FormComponentsProvider");
  }
  return ctx;
}

export { FormComponentsContext, useFormComponents };
